var map = {
	"./filled/Credito_automatico.svg": [
		22434,
		22434
	],
	"./filled/Credito_consignado.svg": [
		18169,
		18169
	],
	"./filled/Credito_imobiliario.svg": [
		39108,
		39108
	],
	"./filled/Itoken.svg": [
		7419,
		7419
	],
	"./filled/Viagem.svg": [
		45598,
		45598
	],
	"./filled/acoes.svg": [
		28138,
		28138
	],
	"./filled/agencia-personalite.svg": [
		65884,
		65884
	],
	"./filled/agencia.svg": [
		78147,
		78147
	],
	"./filled/agil.svg": [
		4767,
		27148
	],
	"./filled/ajuda.svg": [
		39058,
		39058
	],
	"./filled/alimentacao.svg": [
		31809,
		31809
	],
	"./filled/alvo.svg": [
		81509,
		81509
	],
	"./filled/antecipacao_de_recebimento.svg": [
		95499,
		95499
	],
	"./filled/aplicativos.svg": [
		16424,
		16424
	],
	"./filled/aporte-de-capital.svg": [
		2309,
		2309
	],
	"./filled/ar_condicionado.svg": [
		40401,
		40401
	],
	"./filled/armario.svg": [
		55934,
		55934
	],
	"./filled/arroba.svg": [
		63836,
		63836
	],
	"./filled/atendimento.svg": [
		60455,
		60455
	],
	"./filled/atualizando.svg": [
		97845,
		97845
	],
	"./filled/autoriza-pelo-celular.svg": [
		3612,
		3612
	],
	"./filled/aviso.svg": [
		31205,
		31205
	],
	"./filled/balanco-de-caixa.svg": [
		37114,
		37114
	],
	"./filled/beleza.svg": [
		29658,
		29658
	],
	"./filled/beneficios.svg": [
		5934,
		5934
	],
	"./filled/bike.svg": [
		90504,
		90504
	],
	"./filled/biometria.svg": [
		23853,
		23853
	],
	"./filled/brilho-nos-olhos.svg": [
		10302,
		10302
	],
	"./filled/busca.svg": [
		30231,
		30231
	],
	"./filled/caixa-eletronico.svg": [
		38422,
		38422
	],
	"./filled/calendario.svg": [
		87365,
		87365
	],
	"./filled/carrinho.svg": [
		13705,
		13705
	],
	"./filled/cartao-de-seguranca.svg": [
		38663,
		38663
	],
	"./filled/cartao.svg": [
		44045,
		44045
	],
	"./filled/carteira-digital.svg": [
		1963,
		1963
	],
	"./filled/carteiras-digitais-full.svg": [
		29170,
		29170
	],
	"./filled/cartoes.svg": [
		92868,
		92868
	],
	"./filled/celular-pre-pago.svg": [
		52899,
		52899
	],
	"./filled/celular.svg": [
		82523,
		82523
	],
	"./filled/chat-aguardando.svg": [
		30644,
		30644
	],
	"./filled/chat-erro.svg": [
		19114,
		19114
	],
	"./filled/chave.svg": [
		40527,
		62908
	],
	"./filled/checkbox.svg": [
		82552,
		82552
	],
	"./filled/cheque.svg": [
		62618,
		62618
	],
	"./filled/chip.svg": [
		39037,
		39037
	],
	"./filled/cifrao.svg": [
		9027,
		9027
	],
	"./filled/cinema.svg": [
		81334,
		81334
	],
	"./filled/coleta.svg": [
		95577,
		95577
	],
	"./filled/compartilhar.svg": [
		39143,
		39143
	],
	"./filled/compra.svg": [
		37193,
		37193
	],
	"./filled/compras.svg": [
		48040,
		48040
	],
	"./filled/comprovante.svg": [
		42335,
		42335
	],
	"./filled/computador.svg": [
		29217,
		29217
	],
	"./filled/configuracao.svg": [
		96312,
		96312
	],
	"./filled/confirmacao.svg": [
		70049,
		70049
	],
	"./filled/cons-investimento.svg": [
		65794,
		65794
	],
	"./filled/consorcio-auto.svg": [
		42466,
		42466
	],
	"./filled/consorcio-imobiliario.svg": [
		84287,
		84287
	],
	"./filled/consorcio.svg": [
		28054,
		28054
	],
	"./filled/conta-corrente.svg": [
		91287,
		91287
	],
	"./filled/contatos.svg": [
		5750,
		5750
	],
	"./filled/copiar.svg": [
		39765,
		39765
	],
	"./filled/craques.svg": [
		91503,
		91503
	],
	"./filled/credito-auto.svg": [
		75729,
		75729
	],
	"./filled/credito-sob-medida.svg": [
		10119,
		10119
	],
	"./filled/credito.svg": [
		90507,
		90507
	],
	"./filled/csv.svg": [
		66893,
		66893
	],
	"./filled/cultura.svg": [
		279,
		279
	],
	"./filled/curtir.svg": [
		26324,
		26324
	],
	"./filled/debito.svg": [
		55682,
		55682
	],
	"./filled/desafios.svg": [
		42535,
		42535
	],
	"./filled/desbloqueio.svg": [
		31781,
		31781
	],
	"./filled/descurtir.svg": [
		15442,
		15442
	],
	"./filled/diario.svg": [
		43875,
		43875
	],
	"./filled/documento.svg": [
		83771,
		83771
	],
	"./filled/documentos-pasta.svg": [
		84576,
		84576
	],
	"./filled/download.svg": [
		87315,
		87315
	],
	"./filled/editar.svg": [
		74594,
		74594
	],
	"./filled/email-resposta-rapida.svg": [
		52879,
		52879
	],
	"./filled/empresa.svg": [
		36872,
		36872
	],
	"./filled/emprestimo.svg": [
		19946,
		19946
	],
	"./filled/enviar.svg": [
		10272,
		10272
	],
	"./filled/esporte.svg": [
		27527,
		27527
	],
	"./filled/excel.svg": [
		45904,
		45904
	],
	"./filled/excluir.svg": [
		37575,
		37575
	],
	"./filled/facebook.svg": [
		35051,
		35051
	],
	"./filled/fatura.svg": [
		33234,
		33234
	],
	"./filled/favorito.svg": [
		87837,
		87837
	],
	"./filled/feedback.svg": [
		72862,
		72862
	],
	"./filled/fingerprint.svg": [
		60121,
		60121
	],
	"./filled/flash-desabilitado.svg": [
		51221,
		51221
	],
	"./filled/flash-habilitado.svg": [
		39781,
		39781
	],
	"./filled/futebol.svg": [
		10060,
		10060
	],
	"./filled/garantia.svg": [
		4820,
		4820
	],
	"./filled/gerenciador-de-vendas.svg": [
		43298,
		43298
	],
	"./filled/gestao-de-crises.svg": [
		4392,
		4392
	],
	"./filled/globo.svg": [
		21972,
		21972
	],
	"./filled/historico-de-rentabilidade.svg": [
		94582,
		94582
	],
	"./filled/home.svg": [
		29610,
		29610
	],
	"./filled/impressora.svg": [
		29958,
		29958
	],
	"./filled/informacao.svg": [
		25180,
		25180
	],
	"./filled/inovacao.svg": [
		99809,
		99809
	],
	"./filled/instagram.svg": [
		7865,
		7865
	],
	"./filled/institucional.svg": [
		96673,
		96673
	],
	"./filled/investimento.svg": [
		91288,
		91288
	],
	"./filled/itaupass.svg": [
		17489,
		17489
	],
	"./filled/itoken-chaveiro.svg": [
		56787,
		56787
	],
	"./filled/jornal.svg": [
		64649,
		64649
	],
	"./filled/lavagem-de-dinheiro.svg": [
		25735,
		25735
	],
	"./filled/lideranca.svg": [
		68554,
		68554
	],
	"./filled/limite.svg": [
		4801,
		4801
	],
	"./filled/link-externo.svg": [
		76537,
		76537
	],
	"./filled/logo-itau.svg": [
		77550
	],
	"./filled/logo-laranja.svg": [
		98250
	],
	"./filled/loja.svg": [
		22275,
		22275
	],
	"./filled/maiores-limites.svg": [
		29383,
		29383
	],
	"./filled/mala.svg": [
		78524,
		78524
	],
	"./filled/maquina-cartao.svg": [
		65838,
		65838
	],
	"./filled/maquina-fotografica.svg": [
		26417,
		26417
	],
	"./filled/maquina-pos.svg": [
		46738,
		46738
	],
	"./filled/maximizar.svg": [
		60545,
		60545
	],
	"./filled/metro.svg": [
		44742,
		44742
	],
	"./filled/microfone.svg": [
		29823,
		29823
	],
	"./filled/minimizar.svg": [
		66643,
		66643
	],
	"./filled/notificacao.svg": [
		19491,
		19491
	],
	"./filled/olho-ativo.svg": [
		69519,
		69519
	],
	"./filled/olho-inativo.svg": [
		32788,
		32788
	],
	"./filled/onibus.svg": [
		44761,
		44761
	],
	"./filled/orientador-de-credito.svg": [
		23501,
		23501
	],
	"./filled/pagamento-ao-fornecedor.svg": [
		79722,
		79722
	],
	"./filled/paixao.svg": [
		95705,
		95705
	],
	"./filled/parcelamento.svg": [
		96280,
		96280
	],
	"./filled/pdf.svg": [
		42639,
		42639
	],
	"./filled/perfil-do-investidor.svg": [
		45005,
		45005
	],
	"./filled/pers-conta.svg": [
		40217,
		40217
	],
	"./filled/pet.svg": [
		98010,
		98010
	],
	"./filled/pix-pix.svg": [
		16870,
		16870
	],
	"./filled/portabilidade.svg": [
		73173,
		73173
	],
	"./filled/poupanca.svg": [
		29390,
		29390
	],
	"./filled/premio.svg": [
		40991,
		40991
	],
	"./filled/presente.svg": [
		85161,
		85161
	],
	"./filled/prevencao-de-fraude.svg": [
		1722,
		1722
	],
	"./filled/previdencia.svg": [
		19991,
		19991
	],
	"./filled/processos.svg": [
		95380,
		95380
	],
	"./filled/programa-de-pontos.svg": [
		88784,
		88784
	],
	"./filled/proibido-fumar.svg": [
		76339,
		76339
	],
	"./filled/projeto-sucessorio.svg": [
		2312,
		2312
	],
	"./filled/radio-button.svg": [
		13313,
		13313
	],
	"./filled/radio.svg": [
		62100,
		62100
	],
	"./filled/relatorios-financeiros.svg": [
		59413,
		59413
	],
	"./filled/relogio.svg": [
		64614,
		64614
	],
	"./filled/responder.svg": [
		62891,
		62891
	],
	"./filled/responsabilidade-social.svg": [
		66392,
		66392
	],
	"./filled/restaurar.svg": [
		48342,
		48342
	],
	"./filled/salario.svg": [
		54452,
		54452
	],
	"./filled/saldo.svg": [
		10710,
		10710
	],
	"./filled/salvar.svg": [
		89460,
		89460
	],
	"./filled/saude.svg": [
		36269,
		36269
	],
	"./filled/seguranca-da-informacao.svg": [
		4,
		4
	],
	"./filled/seguranca-patrimonial.svg": [
		92517,
		92517
	],
	"./filled/seguranca-redes-sociais.svg": [
		81984,
		81984
	],
	"./filled/seguranca.svg": [
		29850,
		29850
	],
	"./filled/seguro-auto.svg": [
		65522,
		65522
	],
	"./filled/seguro-cartao.svg": [
		57997,
		57997
	],
	"./filled/seguro-crianca.svg": [
		18872,
		18872
	],
	"./filled/seguro-de-credito.svg": [
		10739,
		10739
	],
	"./filled/seguro-empresas.svg": [
		68251,
		68251
	],
	"./filled/seguro-fraude.svg": [
		88524,
		88524
	],
	"./filled/seguro-mulher.svg": [
		22728,
		22728
	],
	"./filled/seguro-patrimonial.svg": [
		34161,
		34161
	],
	"./filled/seguro-pet.svg": [
		82074,
		82074
	],
	"./filled/seguro-prestamista.svg": [
		88388,
		88388
	],
	"./filled/seguro-renda.svg": [
		52347,
		52347
	],
	"./filled/seguro-residencial.svg": [
		91846,
		91846
	],
	"./filled/seguro-responsabilidade-social.svg": [
		80152,
		80152
	],
	"./filled/seguro-transporte.svg": [
		57231,
		57231
	],
	"./filled/seguro-viagem.svg": [
		15454,
		15454
	],
	"./filled/seguro-vida.svg": [
		47813,
		47813
	],
	"./filled/seguro.svg": [
		45529,
		67910
	],
	"./filled/selecao-terceiros-full.svg": [
		3922,
		3922
	],
	"./filled/senha-circulo.svg": [
		90524,
		90524
	],
	"./filled/senha.svg": [
		99242,
		99242
	],
	"./filled/sms-chat.svg": [
		82473,
		82473
	],
	"./filled/sonho-grande.svg": [
		98336,
		98336
	],
	"./filled/sorriso.svg": [
		52364,
		52364
	],
	"./filled/suporte.svg": [
		31779,
		31779
	],
	"./filled/sustentabilidade.svg": [
		46984,
		46984
	],
	"./filled/switch.svg": [
		70923,
		70923
	],
	"./filled/tablet.svg": [
		23435,
		23435
	],
	"./filled/teatro.svg": [
		6944,
		6944
	],
	"./filled/telefone.svg": [
		11929,
		11929
	],
	"./filled/timeline.svg": [
		81746,
		81746
	],
	"./filled/todos-pelo-cliente.svg": [
		90108,
		90108
	],
	"./filled/transporte.svg": [
		79791,
		79791
	],
	"./filled/twitter.svg": [
		87812,
		87812
	],
	"./filled/txt.svg": [
		49917,
		49917
	],
	"./filled/universitarios.svg": [
		63894,
		63894
	],
	"./filled/upload.svg": [
		8572,
		8572
	],
	"./filled/usuario.svg": [
		28253,
		28253
	],
	"./filled/veiculo.svg": [
		54042,
		54042
	],
	"./filled/venda.svg": [
		43127,
		43127
	],
	"./filled/vestuario.svg": [
		44271,
		44271
	],
	"./filled/vida-sustentavel.svg": [
		53016,
		53016
	],
	"./filled/vida.svg": [
		69829,
		69829
	],
	"./filled/video.svg": [
		61420,
		61420
	],
	"./filled/word.svg": [
		11575,
		11575
	],
	"./filled/xicara.svg": [
		68429,
		68429
	],
	"./likert/bad.svg": [
		14539
	],
	"./likert/dislike.svg": [
		50051
	],
	"./likert/idk.svg": [
		20056
	],
	"./likert/like.svg": [
		26255
	],
	"./likert/loved.svg": [
		97650
	],
	"./outlined/acoes-grafico.svg": [
		4058,
		4058
	],
	"./outlined/acoes.svg": [
		70780,
		70780
	],
	"./outlined/adicionar.svg": [
		33965,
		33965
	],
	"./outlined/agencia-personalite.svg": [
		38574,
		38574
	],
	"./outlined/agencia.svg": [
		99109,
		99109
	],
	"./outlined/agil.svg": [
		33034,
		33034
	],
	"./outlined/ajuda.svg": [
		81748,
		81748
	],
	"./outlined/alimentacao.svg": [
		17835,
		17835
	],
	"./outlined/alvo.svg": [
		43959,
		43959
	],
	"./outlined/antecipacao-de-recebimento.svg": [
		48705,
		48705
	],
	"./outlined/aplicativos.svg": [
		51950,
		51950
	],
	"./outlined/aporte-de-capital.svg": [
		20719,
		20719
	],
	"./outlined/ar_condicionado.svg": [
		7411,
		7411
	],
	"./outlined/armario.svg": [
		95688,
		95688
	],
	"./outlined/arroba.svg": [
		68934,
		68934
	],
	"./outlined/assessoria.svg": [
		93106,
		93106
	],
	"./outlined/atendimento-telefonico.svg": [
		86706,
		86706
	],
	"./outlined/atendimento.svg": [
		67449,
		67449
	],
	"./outlined/atualizando.svg": [
		17191,
		17191
	],
	"./outlined/autoriza-pelo-celular.svg": [
		92234,
		92234
	],
	"./outlined/aviso.svg": [
		75591
	],
	"./outlined/banco-de-caixa.svg": [
		16969,
		16969
	],
	"./outlined/beleza.svg": [
		82439,
		82439
	],
	"./outlined/beneficios.svg": [
		54968,
		54968
	],
	"./outlined/bike.svg": [
		87090,
		87090
	],
	"./outlined/biometria-facial.svg": [
		93120,
		93120
	],
	"./outlined/biometria.svg": [
		54871,
		54871
	],
	"./outlined/bomba-gas.svg": [
		66842,
		66842
	],
	"./outlined/brilho-nos-olhos.svg": [
		87236
	],
	"./outlined/busca.svg": [
		40537,
		40537
	],
	"./outlined/cadastro-positivo.svg": [
		65286,
		65286
	],
	"./outlined/caixa-eletronico.svg": [
		93974,
		38736
	],
	"./outlined/caixas-exclusivos.svg": [
		27470,
		27470
	],
	"./outlined/calculadora.svg": [
		79554,
		79554
	],
	"./outlined/calendario.svg": [
		75895,
		75895
	],
	"./outlined/cambio.svg": [
		70316,
		70316
	],
	"./outlined/caminhao.svg": [
		16893,
		16893
	],
	"./outlined/caminhonete.svg": [
		36950,
		36950
	],
	"./outlined/cancela.svg": [
		67620,
		67620
	],
	"./outlined/carrinho.svg": [
		50615,
		50615
	],
	"./outlined/cartao-de-seguranca.svg": [
		67709,
		67709
	],
	"./outlined/cartao.svg": [
		93867,
		93867
	],
	"./outlined/carteira-digital.svg": [
		14925,
		14925
	],
	"./outlined/carteirada.svg": [
		72511,
		72511
	],
	"./outlined/carteiras-digitais.svg": [
		24550,
		24550
	],
	"./outlined/cartoes.svg": [
		84858,
		84858
	],
	"./outlined/celular-card.svg": [
		97328,
		97328
	],
	"./outlined/celular-pre-pago.svg": [
		41441,
		41441
	],
	"./outlined/celular.svg": [
		21201,
		21201
	],
	"./outlined/chat-aguardando.svg": [
		56518,
		56518
	],
	"./outlined/chat-entregue.svg": [
		54901,
		54901
	],
	"./outlined/chat-enviado.svg": [
		88880,
		88880
	],
	"./outlined/chat-erro.svg": [
		37864,
		37864
	],
	"./outlined/chave.svg": [
		68378,
		68378
	],
	"./outlined/check.svg": [
		17783
	],
	"./outlined/checkbox-indeterminado.svg": [
		69698,
		69698
	],
	"./outlined/checkbox-vazio.svg": [
		4418,
		4418
	],
	"./outlined/checkbox.svg": [
		66326,
		66326
	],
	"./outlined/cheque.svg": [
		50728,
		50728
	],
	"./outlined/chip.svg": [
		45035,
		45035
	],
	"./outlined/cifrao.svg": [
		91589,
		91589
	],
	"./outlined/cinema.svg": [
		92320,
		92320
	],
	"./outlined/cobranca.svg": [
		31350,
		31350
	],
	"./outlined/codigo-de-barras.svg": [
		76998,
		76998
	],
	"./outlined/coleta.svg": [
		84139,
		84139
	],
	"./outlined/compartilhar.svg": [
		24697,
		24697
	],
	"./outlined/compra.svg": [
		74167,
		74167
	],
	"./outlined/compras.svg": [
		44038,
		44038
	],
	"./outlined/comprovante.svg": [
		22229,
		22229
	],
	"./outlined/computador.svg": [
		89219,
		89219
	],
	"./outlined/conectcar-adesivo.svg": [
		73859,
		73859
	],
	"./outlined/conectcar.svg": [
		52521,
		52521
	],
	"./outlined/configuracao.svg": [
		97778,
		97778
	],
	"./outlined/confirmacao.svg": [
		68451,
		68451
	],
	"./outlined/cons-investimento.svg": [
		81532,
		81532
	],
	"./outlined/cons-investimentos.svg": [
		87255,
		87255
	],
	"./outlined/consorcio-auto.svg": [
		6352,
		6352
	],
	"./outlined/consorcio-imobiliario.svg": [
		65317,
		65317
	],
	"./outlined/consorcio.svg": [
		32996,
		32996
	],
	"./outlined/conta-corrente.svg": [
		77489,
		77489
	],
	"./outlined/contatos.svg": [
		31348,
		31348
	],
	"./outlined/conti-negocios.svg": [
		15440,
		15440
	],
	"./outlined/contraste-off.svg": [
		47844,
		47844
	],
	"./outlined/contraste-on.svg": [
		21038,
		21038
	],
	"./outlined/copiar.svg": [
		86539
	],
	"./outlined/coracao.svg": [
		74203,
		74203
	],
	"./outlined/craques.svg": [
		81665,
		81665
	],
	"./outlined/credito-auto.svg": [
		40139,
		40139
	],
	"./outlined/credito-automatico.svg": [
		59014,
		59014
	],
	"./outlined/credito-consignado.svg": [
		90909,
		90909
	],
	"./outlined/credito-imobiliario.svg": [
		22640,
		22640
	],
	"./outlined/credito-sob-medida.svg": [
		3737,
		3737
	],
	"./outlined/credito.svg": [
		75973,
		75973
	],
	"./outlined/csv.svg": [
		45215,
		45215
	],
	"./outlined/cultura.svg": [
		31485,
		31485
	],
	"./outlined/curtir.svg": [
		12458,
		12458
	],
	"./outlined/debito.svg": [
		15924,
		15924
	],
	"./outlined/dente.svg": [
		56431,
		56431
	],
	"./outlined/deposito.svg": [
		62992,
		62992
	],
	"./outlined/desafios.svg": [
		53465,
		53465
	],
	"./outlined/desbloqueio.svg": [
		57432,
		57432
	],
	"./outlined/descurtir.svg": [
		10720,
		10720
	],
	"./outlined/diario.svg": [
		55477,
		55477
	],
	"./outlined/documento.svg": [
		88593,
		88593
	],
	"./outlined/documentos-pasta.svg": [
		75306,
		75306
	],
	"./outlined/download.svg": [
		47341,
		47341
	],
	"./outlined/e-comercial.svg": [
		14224,
		14224
	],
	"./outlined/editar.svg": [
		69232
	],
	"./outlined/email-resposta-rapida.svg": [
		13113
	],
	"./outlined/empresas.svg": [
		88793,
		88793
	],
	"./outlined/emprestimo.svg": [
		32352,
		32352
	],
	"./outlined/enviar.svg": [
		16694,
		16694
	],
	"./outlined/esporte.svg": [
		80209,
		80209
	],
	"./outlined/euro.svg": [
		93538,
		93538
	],
	"./outlined/excel.svg": [
		84466,
		84466
	],
	"./outlined/excluir.svg": [
		1485,
		1485
	],
	"./outlined/extrato.svg": [
		80910,
		80910
	],
	"./outlined/facebook.svg": [
		87797,
		87797
	],
	"./outlined/faceid.svg": [
		99101,
		99101
	],
	"./outlined/fatura.svg": [
		99788,
		99788
	],
	"./outlined/favorito.svg": [
		6027,
		6027
	],
	"./outlined/fechar.svg": [
		28150
	],
	"./outlined/feedback.svg": [
		0,
		0
	],
	"./outlined/ferramentas.svg": [
		68363,
		68363
	],
	"./outlined/filtro.svg": [
		57063,
		57063
	],
	"./outlined/fingerprint.svg": [
		64087,
		64087
	],
	"./outlined/flash-desabilitado.svg": [
		39035,
		39035
	],
	"./outlined/flash-habilitado.svg": [
		90639,
		90639
	],
	"./outlined/futebol.svg": [
		47966,
		47966
	],
	"./outlined/garantia.svg": [
		25130,
		25130
	],
	"./outlined/gerenciador-de-vendas.svg": [
		50412,
		50412
	],
	"./outlined/gerente-dedicado.svg": [
		78353,
		78353
	],
	"./outlined/gerente.svg": [
		1341,
		1341
	],
	"./outlined/gestao-de-crises.svg": [
		26710,
		26710
	],
	"./outlined/globo.svg": [
		88362,
		88362
	],
	"./outlined/historico-de-rentabilidade.svg": [
		26888,
		26888
	],
	"./outlined/home.svg": [
		89192,
		89192
	],
	"./outlined/icarros.svg": [
		60208,
		60208
	],
	"./outlined/imposto-de-renda.svg": [
		2093,
		2093
	],
	"./outlined/impressora.svg": [
		45924,
		45924
	],
	"./outlined/informação.svg": [
		76856
	],
	"./outlined/inovacao.svg": [
		96519,
		96519
	],
	"./outlined/inss.svg": [
		85538,
		85538
	],
	"./outlined/instagram.svg": [
		51391,
		51391
	],
	"./outlined/institucional.svg": [
		6411,
		6411
	],
	"./outlined/investimento.svg": [
		89270,
		89270
	],
	"./outlined/iso.svg": [
		77856,
		77856
	],
	"./outlined/itaupass.svg": [
		96211,
		96211
	],
	"./outlined/itoken-chaveiro-1.svg": [
		39295,
		39295
	],
	"./outlined/itoken-chaveiro.svg": [
		31117,
		31117
	],
	"./outlined/itoken.svg": [
		32145,
		32145
	],
	"./outlined/jornal.svg": [
		91091,
		91091
	],
	"./outlined/juros.svg": [
		9094,
		9094
	],
	"./outlined/lavagem-de-dinheiro.svg": [
		12305,
		12305
	],
	"./outlined/lideranca.svg": [
		92716,
		92716
	],
	"./outlined/limite.svg": [
		7715,
		7715
	],
	"./outlined/link-externo.svg": [
		30303,
		30303
	],
	"./outlined/loja.svg": [
		79061,
		79061
	],
	"./outlined/maioires-limites-alt.svg": [
		86406,
		86406
	],
	"./outlined/maiores-limites.svg": [
		47917,
		47917
	],
	"./outlined/mais.svg": [
		47939
	],
	"./outlined/mala.svg": [
		90966,
		90966
	],
	"./outlined/maquina-cartao.svg": [
		75112,
		75112
	],
	"./outlined/maquina-fotografica.svg": [
		31935,
		31935
	],
	"./outlined/maquina-pos.svg": [
		11156,
		11156
	],
	"./outlined/maximizar.svg": [
		59159,
		59159
	],
	"./outlined/menos.svg": [
		69465
	],
	"./outlined/menu-hamburger.svg": [
		8878,
		8878
	],
	"./outlined/metro.svg": [
		39284,
		39284
	],
	"./outlined/microfone.svg": [
		89413,
		89413
	],
	"./outlined/moto.svg": [
		63854,
		63854
	],
	"./outlined/nfc.svg": [
		85064,
		85064
	],
	"./outlined/notificacao.svg": [
		81953,
		81953
	],
	"./outlined/olho-ativo.svg": [
		40337,
		40337
	],
	"./outlined/olho-inativo.svg": [
		72490,
		72490
	],
	"./outlined/onibus.svg": [
		59643,
		59643
	],
	"./outlined/open-finance.svg": [
		90048,
		90048
	],
	"./outlined/ordenar-crescente.svg": [
		26555,
		26555
	],
	"./outlined/ordenar-decrescente.svg": [
		33588,
		33588
	],
	"./outlined/ordenar-direita.svg": [
		56811,
		56811
	],
	"./outlined/ordenar-esquerda.svg": [
		65741,
		65741
	],
	"./outlined/ordenar.svg": [
		6570,
		6570
	],
	"./outlined/orientacao-de-credito.svg": [
		98883,
		98883
	],
	"./outlined/outros.svg": [
		82381,
		82381
	],
	"./outlined/pagamento-ao-fornecedor.svg": [
		18548,
		18548
	],
	"./outlined/pagamentos.svg": [
		12566,
		12566
	],
	"./outlined/paixao.svg": [
		80271,
		80271
	],
	"./outlined/parcelamento.svg": [
		90002,
		90002
	],
	"./outlined/pdf.svg": [
		59001,
		59001
	],
	"./outlined/perfil-do-investidor.svg": [
		88591,
		88591
	],
	"./outlined/pers-conta.svg": [
		47527,
		47527
	],
	"./outlined/pet.svg": [
		3496,
		3496
	],
	"./outlined/pix.svg": [
		66112,
		66112
	],
	"./outlined/play.svg": [
		83803,
		83803
	],
	"./outlined/porcentagem.svg": [
		87644,
		87644
	],
	"./outlined/portabilidade.svg": [
		79415,
		79415
	],
	"./outlined/poupanca.svg": [
		1116,
		1116
	],
	"./outlined/predio.svg": [
		31180,
		31180
	],
	"./outlined/premio.svg": [
		85609,
		85609
	],
	"./outlined/presente.svg": [
		39959,
		39959
	],
	"./outlined/prevencao-de-fraude.svg": [
		76044,
		76044
	],
	"./outlined/previdencia.svg": [
		9557,
		9557
	],
	"./outlined/processos.svg": [
		99238,
		99238
	],
	"./outlined/produtos.svg": [
		84319,
		84319
	],
	"./outlined/programa-de-pontos.svg": [
		34386,
		34386
	],
	"./outlined/proibido-fumar.svg": [
		45909,
		45909
	],
	"./outlined/projeto-sucessorio.svg": [
		37886,
		37886
	],
	"./outlined/qrcode.svg": [
		42299,
		42299
	],
	"./outlined/radio-button.svg": [
		79655,
		79655
	],
	"./outlined/radio.svg": [
		27082,
		27082
	],
	"./outlined/recarga.svg": [
		29112,
		29112
	],
	"./outlined/recarregar.svg": [
		53919,
		53919
	],
	"./outlined/refresh.svg": [
		21514,
		21514
	],
	"./outlined/relatorios-financeiros.svg": [
		77527,
		77527
	],
	"./outlined/relogio.svg": [
		12860,
		12860
	],
	"./outlined/resgate.svg": [
		92156,
		92156
	],
	"./outlined/responder.svg": [
		23325,
		23325
	],
	"./outlined/responsabilidade-social.svg": [
		50194,
		50194
	],
	"./outlined/resposta.svg": [
		77844,
		77844
	],
	"./outlined/restaurar.svg": [
		62652,
		62652
	],
	"./outlined/sacola.svg": [
		98346,
		98346
	],
	"./outlined/sair-do-vermelho.svg": [
		96423,
		96423
	],
	"./outlined/sair.svg": [
		1276,
		1276
	],
	"./outlined/salario.svg": [
		84270,
		84270
	],
	"./outlined/saldo.svg": [
		22612,
		22612
	],
	"./outlined/salvar.svg": [
		40666,
		40666
	],
	"./outlined/saque.svg": [
		96172,
		96172
	],
	"./outlined/saude.svg": [
		16839,
		16839
	],
	"./outlined/seguranca-da-informacao.svg": [
		78910,
		78910
	],
	"./outlined/seguranca-patrimonial.svg": [
		6619,
		6619
	],
	"./outlined/seguranca-redes-sociais.svg": [
		77666,
		77666
	],
	"./outlined/seguranca.svg": [
		48012,
		48012
	],
	"./outlined/seguro-auto.svg": [
		44236,
		44236
	],
	"./outlined/seguro-cartao.svg": [
		68047,
		68047
	],
	"./outlined/seguro-crianca.svg": [
		72346,
		72346
	],
	"./outlined/seguro-de-credito.svg": [
		98269,
		98269
	],
	"./outlined/seguro-empresas.svg": [
		26405,
		26405
	],
	"./outlined/seguro-fraude.svg": [
		52698,
		52698
	],
	"./outlined/seguro-mulher.svg": [
		20850,
		20850
	],
	"./outlined/seguro-patrimonial.svg": [
		30087,
		30087
	],
	"./outlined/seguro-pet.svg": [
		50068,
		50068
	],
	"./outlined/seguro-prestamista.svg": [
		97330,
		97330
	],
	"./outlined/seguro-renda.svg": [
		17069,
		17069
	],
	"./outlined/seguro-residencial.svg": [
		55752,
		55752
	],
	"./outlined/seguro-responsabilidade-social.svg": [
		33214,
		33214
	],
	"./outlined/seguro-transporte.svg": [
		63945,
		63945
	],
	"./outlined/seguro-viagem.svg": [
		10972,
		10972
	],
	"./outlined/seguro-vida.svg": [
		40223,
		40223
	],
	"./outlined/seguro.svg": [
		3304,
		3304
	],
	"./outlined/selecao-terceiros.svg": [
		24362,
		24362
	],
	"./outlined/sem-anuidade.svg": [
		45264,
		45264
	],
	"./outlined/senha-box.svg": [
		47344,
		47344
	],
	"./outlined/senha-circulo.svg": [
		35010,
		35010
	],
	"./outlined/seta-baixo-achatada.svg": [
		30532,
		30532
	],
	"./outlined/seta-baixo.svg": [
		54940
	],
	"./outlined/seta-cima-achatada.svg": [
		60849,
		60849
	],
	"./outlined/seta-cima.svg": [
		71143,
		71143
	],
	"./outlined/seta-direita.svg": [
		45389
	],
	"./outlined/seta-esquerda.svg": [
		33759,
		33759
	],
	"./outlined/sms-chat.svg": [
		95727,
		95727
	],
	"./outlined/sonho-grande.svg": [
		20150,
		20150
	],
	"./outlined/sorriso.svg": [
		554,
		554
	],
	"./outlined/suporte.svg": [
		9165,
		9165
	],
	"./outlined/sustentabilidade.svg": [
		38538,
		38538
	],
	"./outlined/swipe.svg": [
		82017,
		82017
	],
	"./outlined/switch.svg": [
		1305,
		1305
	],
	"./outlined/tablet.svg": [
		86937,
		86937
	],
	"./outlined/teatro.svg": [
		97458,
		97458
	],
	"./outlined/telefone.svg": [
		78655,
		78655
	],
	"./outlined/timeline.svg": [
		6288,
		6288
	],
	"./outlined/todos-pelo-cliente.svg": [
		15350,
		15350
	],
	"./outlined/tooltip.svg": [
		11718,
		11718
	],
	"./outlined/transferencia.svg": [
		62330,
		62330
	],
	"./outlined/transporte.svg": [
		33277,
		33277
	],
	"./outlined/tv.svg": [
		84891,
		84891
	],
	"./outlined/twitter.svg": [
		97474,
		97474
	],
	"./outlined/txt.svg": [
		67259,
		67259
	],
	"./outlined/universitarios.svg": [
		21508,
		21508
	],
	"./outlined/upload.svg": [
		62810,
		62810
	],
	"./outlined/user.svg": [
		18184
	],
	"./outlined/veiculo.svg": [
		51908,
		51908
	],
	"./outlined/venda.svg": [
		83069,
		83069
	],
	"./outlined/vestuario.svg": [
		2037,
		2037
	],
	"./outlined/viagem.svg": [
		75480,
		75480
	],
	"./outlined/vida-sustentavel.svg": [
		89854,
		89854
	],
	"./outlined/vida.svg": [
		27595,
		27595
	],
	"./outlined/video.svg": [
		51826,
		51826
	],
	"./outlined/whatsapp.svg": [
		99127,
		99127
	],
	"./outlined/wifi.svg": [
		5834,
		5834
	],
	"./outlined/word.svg": [
		82853,
		82853
	],
	"./outlined/xicara.svg": [
		11543,
		11543
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 7 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 81691;
module.exports = webpackAsyncContext;